import { useEffect } from "react";

const SCROLL_KEYS = new Set([
  "ArrowUp",
  "ArrowDown",
  "PageUp",
  "PageDown",
  "Home",
  "End",
  " ",
]);

/**
 * Locks background page scroll when `isLocked` is true without changing layout
 * (no overflow/position/padding changes), so the scrollbar and fixed elements
 * do not shift. Scroll inputs are blocked; any movement that still occurs is
 * snapped back to the locked position.
 */
const useBodyScrollLock = (isLocked: boolean): void => {
  useEffect(() => {
    if (!isLocked || typeof window === "undefined") return;

    const lockedScrollX = window.scrollX;
    const lockedScrollY = window.scrollY;

    const preventScroll = (event: Event) => {
      event.preventDefault();
    };

    const preventScrollKeys = (event: KeyboardEvent) => {
      if (SCROLL_KEYS.has(event.key)) {
        event.preventDefault();
      }
    };

    const restoreScroll = () => {
      window.scrollTo(lockedScrollX, lockedScrollY);
    };

    window.addEventListener("wheel", preventScroll, { passive: false });
    window.addEventListener("touchmove", preventScroll, { passive: false });
    window.addEventListener("keydown", preventScrollKeys);
    window.addEventListener("scroll", restoreScroll, { passive: true });

    return () => {
      window.removeEventListener("wheel", preventScroll);
      window.removeEventListener("touchmove", preventScroll);
      window.removeEventListener("keydown", preventScrollKeys);
      window.removeEventListener("scroll", restoreScroll);
    };
  }, [isLocked]);
};

export default useBodyScrollLock;
